<template>
  <section class="expanded-picture">
    <header class="product-header-parent">
      <h2 class="product-header">{{ name }}</h2>
    </header>
    <img v-if="buildNumber"
      class="landscape fullscreenLandscape"
      :src="`${staticUrl}Images/${fileName}` + '?' + buildNumber"
    />
    <img
      class="minimize-icon"
      src="../assets/eds-icons/minimize.svg"
      @click="minimize()"
    />
  </section>
</template>

<script>

import { getStaticUrl } from '@/helpers';
import axios from 'axios';

export default {
  props: ['name', 'section', 'fileName', 'radio'],
  data() {
    return {
      buildNumber: 0
    };
  },
  mounted() {
    axios.get(`${this.staticUrl}assetsConfig.json?` + Date.now()).then(result => {
      this.buildNumber = result.data.buildNumber;
    });
  },
  computed: {
    staticUrl () {
      return getStaticUrl(this.radio, this.$route.name);
    }
  },
  methods: {
    minimize() {
      this.$emit('minimize');
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/light.less';
@import '~@eds/vanilla/variables/global.less';

.expanded-picture {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1000;
  left: 0;
  top: 0;
  display: inline-block;
}
.minimize-icon {
  position: fixed;
  z-index: 100;
  width: 2rem;
  height: 2rem;
  padding: @space-small;
  bottom: @space-large;
  left: @space-large;
  cursor: pointer;
  background-color: @text;
}
.fullscreenLandscape {
  position: absolute;
  top: 0;
  left: 0;
}
.landscape {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.product-header-parent {
  width: auto;
  display: inline-block;
}
.product-header {
  color: @white;
  background-color: fade(@layer0, 70%);
  position: relative;
  z-index: 1001;
  padding: @space-large;
  margin: 0px;
}
</style>
